import { C as g } from "./stimulus-babce4aa.js";
import { f as d } from "./money-db8a5809.js";
import { c as n, p as m } from "./session-283f2efa.js";
import { u as v } from "./index-115a0bec.js";
import { u as y, a as p } from "./cart-dd9773ac.js";
import "./store-cf56b351.js";
import "./_commonjsHelpers-725317a4.js";
import "./native-5b22c04a.js";

class u extends g {
  constructor() {
    super(...arguments);
    this.cart = null;
    this.productCache = new Map();

    // helper to build consistent product url (absolute)
    this.getProductUrl = (handle) =>
      `${window.location.origin}/products/${handle}.js`;

    this.handleNoteUpdate = async () => {
      try {
        const res = await y(JSON.stringify({ note: this.noteValue }));
        console.log("Note Response:", res);
      } catch (err) {
        console.warn("Note update failed", err);
      }
    };

    this.saveItemForLater = async (evt) => {
      try {
        let { savedCart = { items: [] } } = n;
        const { items = [] } = savedCart;
        const btn = evt.currentTarget;
        const { key } = btn.dataset;
        const itemEl = btn.closest("[data-item]");

        btn.textContent = "Moving...";
        const cart = await this.getCartPromise();
        const item = cart.items.find((i) => i.key === key);

        if (window.gtag && item) {
          gtag("event", "click", {
            event_category: "Cart Drawer",
            event_label: "Save For Later",
            value: item.title,
          });
        }

        if (item) items.push(item);
        savedCart.items = items;
        n.savedCart = savedCart;
        m(n);

        if (itemEl) this.removeItemEl(itemEl);
      } catch (err) {
        console.warn("saveItemForLater error", err);
      }
    };

    this.removeItemEl = (el) => {
      if (!el) return;
      el.classList.add("scale-y-0", "opacity-0");
      setTimeout(() => this.handleIsOpening(), 300);
    };

    this.updateCounts = (t) => {
      const { item_count } = t;
      this.cartCountTargets.forEach((el) => (el.textContent = `(${item_count})`));
    };

    this.handleIsOpening = async () => {
      await this.build();
    };

    this.build = async () => {
      await this.buildCart();
      await this.buildSavedCart();
      setTimeout(() => this.loadNosto(), 350);
    };

    this.toggleNote = () => {
      if (this.hasCartNoteTarget) this.cartNoteContainerTarget.classList.toggle("hidden");
    };

    // ---------- Saved Cart ----------
    this.buildSavedCart = async () => {
      const counters = document.querySelectorAll(".saved-cart-count");
      let { savedCart = { items: [] } } = n;
      const { items = [] } = savedCart;

      const getCompareAtPrice = async (item) => {
        try {
          // Try direct handle first
          let handle = item.handle;

          // If no handle, attempt to find variant in cached product objects
          if (!handle) {
            for (const product of this.productCache.values()) {
              if (!product || !product.variants) continue;
              const found = product.variants.find((v) => Number(v.id) === Number(item.variant_id));
              if (found) {
                handle = product.handle;
                break;
              }
            }
            if (!handle) return null;
          }

          const productUrl = this.getProductUrl(handle);
          let productData = this.productCache.get(productUrl);

          if (!productData) {
            const res = await fetch(productUrl);
            if (!res.ok) throw new Error(`Failed to fetch ${productUrl}: ${res.status}`);
            productData = await res.json();
            this.productCache.set(productUrl, productData);
          }

          const variant = (productData.variants || []).find(
            (v) => Number(v.id) === Number(item.variant_id)
          );

          if (variant && Number(variant.compare_at_price) > Number(variant.price)) {
            return Number(variant.compare_at_price);
          }
        } catch (err) {
          console.warn(
            `Failed to fetch compare_at_price for variant_id: ${item.variant_id}`,
            err
          );
        }
        return null;
      };

      try {
        let originalTotal = 0;

        const enrichedItems = await Promise.all(
          items.map(async (it) => {
            const compareAt = await getCompareAtPrice(it);

            if (compareAt) {
              originalTotal += compareAt * (it.quantity || 1);
            } else {
              originalTotal += it.original_line_price ?? (it.line_price * (it.quantity || 1));
            }

            return {
              ...it,
              options_with_values: (it.options_with_values || []).filter(
                (opt) => String(opt.name || "").toLowerCase() !== "title"
              ),
              linePrice: d(it.line_price ?? 0),
              originalLinePrice: d(it.original_line_price ?? (it.line_price * (it.quantity || 1))),
              compareAtPrice: compareAt ? d(compareAt * (it.quantity || 1)) : null,
              actionText: "ADD TO CART",
              itemAction: "click->cartdrawer#moveFromSavedToCart",
              removeAction: "click->cartdrawer#removeFromSaved",
            };
          })
        );

        counters.forEach((c) => (c.textContent = `(${items.length})`));

        if (!this.savedCartBodyTarget) {
          console.warn("savedCartBodyTarget missing - cannot render saved cart");
          return false;
        }

        this.savedCartBodyTarget.innerHTML = this.itemsTemplate({
          cartType: "saved",
          ...savedCart,
          empty: items.length === 0,
          cartTotal: d(items.reduce((sum, i) => sum + (i.line_price || 0), 0)),
          savedCartOriginalTotal: d(originalTotal),
          items: enrichedItems,
        });

        return true;
      } catch (err) {
        console.error("buildSavedCart failed", err);
        return false;
      }
    };

    // ---------- Active cart ----------
    this.buildCart = async () => {
      const cart = await this.getCartPromise();

      const getCompareAtPrice = async (item) => {
        try {
          let handle = item.handle;

          if (!handle) {
            for (const product of this.productCache.values()) {
              if (!product || !product.variants) continue;
              const found = product.variants.find((v) => Number(v.id) === Number(item.variant_id));
              if (found) {
                handle = product.handle;
                break;
              }
            }
            if (!handle) return null;
          }

          const productUrl = this.getProductUrl(handle);
          let productData = this.productCache.get(productUrl);

          if (!productData) {
            const res = await fetch(productUrl);
            if (!res.ok) throw new Error(`Failed to fetch ${productUrl}: ${res.status}`);
            productData = await res.json();
            this.productCache.set(productUrl, productData);
          }

          const variant = (productData.variants || []).find(
            (v) => Number(v.id) === Number(item.variant_id)
          );

          if (variant && Number(variant.compare_at_price) > Number(variant.price)) {
            return Number(variant.compare_at_price);
          }
        } catch (err) {
          console.warn(
            `Failed to fetch compare_at_price for variant_id: ${item.variant_id}`,
            err
          );
        }
        return null;
      };

      let originalTotal = 0;

      const enriched = await Promise.all(
        (cart.items || []).map(async (it) => {
          const compareAt = await getCompareAtPrice(it);

          if (compareAt) originalTotal += compareAt * (it.quantity || 1);
          else originalTotal += it.original_line_price ?? (it.line_price * (it.quantity || 1));

          return {
            ...it,
            options_with_values: (it.options_with_values || []).filter(
              (opt) => String(opt.name || "").toLowerCase() !== "title"
            ),
            linePrice: d(it.line_price ?? 0),
            originalLinePrice: d(it.original_line_price ?? (it.line_price * (it.quantity || 1))),
            compareAtPrice: compareAt ? d(compareAt * (it.quantity || 1)) : null,
            actionText: "SAVE FOR LATER",
            itemAction: "click->cartdrawer#saveItemForLater",
            removeAction: "click->cartdrawer#handleRemove",
          };
        })
      );

      if (this.cartBodyTarget) {
        this.cartBodyTarget.innerHTML = this.itemsTemplate({
          cartType: "userCart",
          ...cart,
          empty: cart.item_count === 0,
          cartTotal: d(cart.total_price || 0),
          cartOriginalTotal: d(originalTotal),
          items: enriched,
        });
      } else {
        console.warn("cartBodyTarget missing - cannot render cart");
      }

      return true;
    };

    // ---------- Saved item actions ----------
    this.removeFromSavedByKey = (key) => {
      let { savedCart = { items: [] } } = n;
      const filtered = (savedCart.items || []).filter((it) => it.key !== key);
      savedCart.items = filtered;
      n.savedCart = savedCart;
      m(n);
    };

    this.removeFromSaved = (event) => {
      try {
        const el = event.currentTarget;
        const { key } = el.dataset;
        const itemEl = el.closest("[data-item]");
        this.removeFromSavedByKey(key);
        this.removeItemEl(itemEl);
        setTimeout(() => this.buildSavedCart(), 300);
      } catch (err) {
        console.warn("removeFromSaved failed", err);
      }
    };

    this.moveFromSavedToCart = async (event) => {
      try {
        const el = event.currentTarget;
        const { key } = el.dataset;
        let { savedCart = { items: [] } } = n;
        const item = (savedCart.items || []).find((i) => i.key === key);
        if (!item) return;

        if (window.gtag) {
          gtag("event", "click", {
            event_category: "Cart Drawer",
            event_label: "Move To Cart",
            value: item.title,
          });
        }

        // add to Shopify cart
        await p({
          items: [{ id: item.variant_id, quantity: item.quantity || 1, properties: item.properties || {} }],
        });

        this.removeFromSavedByKey(key);
        const itemEl = el.closest("[data-item]");
        this.removeItemEl(itemEl);
        setTimeout(() => this.build(), 300);
      } catch (err) {
        console.warn("moveFromSavedToCart failed", err);
      }
    };
  }

  initialize() {}
  connect() {
    v(this);
    console.log("Connect cart Drawer", this.element);
    document.body.addEventListener("cart:open", this.handleIsOpening);
    this.element.addEventListener("drawer:opening", this.handleIsOpening);
    this.element.addEventListener("drawer:opened", this.handleIsOpening);
  }
  disconnect() {}

  get noteValue() {
    return this.cartNoteTarget.value || "";
  }

  getCartPromise() {
    return new Promise((resolve) => {
      window.JM.MiniCart.getCart((a) => {
        this.cart = a;
        this.updateCounts(a);
        resolve(a);
      });
    });
  }

  loadNosto() {
    console.log("Load Nosto:", window.nostojs);
    window.nostojs && window.nostojs((t) => t.loadRecommendations());
    setTimeout(() => {
      $("#cart-drawer-end .product-feed-featured").on("init", () => {});
      $("#cart-drawer-end .product-feed-featured:not(.slick-slider)").slick();
      window.nostoResetFunctions && window.nostoResetFunctions.length && window.nostoResetFunctions.forEach((t) => t());
      $("#cart-drawer-end .recommendation-add").on("click", this.handleRecommendedAdd.bind(this));
      this.loadNostoProducts();
    }, 600);
  }

  async handleRecommendedAdd(e) {
    const clicked = e.target;
    const href = clicked.previousElementSibling && clicked.previousElementSibling.href;
    if (!href) return;
    const url = this.cleanUrl(href);
    const product = this.productCache.get(url);
    if (!product) return;
    const variant = product.variants.find((v) => v.available);
    if (variant) {
      await p({ items: [{ id: variant.id, quantity: 1 }] });
      this.build();
    }
  }

  cleanUrl(t) {
    const e = new URL(t);
    return `${e.origin}${e.pathname}.js`;
  }

  async loadNostoProducts() {
    const anchors = document.querySelectorAll("#cart-drawer-end .product-feed-featured a");
    const toFetch = [...anchors].map((a) => this.cleanUrl(a.href));
    const fetcher = async (url) => {
      if (this.productCache.get(url)) return true;
      try {
        const r = await this.fetchProduct(url);
        this.productCache.set(url, r);
        return r;
      } catch (err) {
        console.warn("loadNostoProducts fetch failed for", url, err);
        return null;
      }
    };
    await Promise.all(toFetch.map(fetcher));
  }

  fetchProduct(t) {
    return fetch(t).then((r) => r.json());
  }

  async reduceQty(evt) {
    evt.preventDefault();
    const btn = evt.currentTarget;
    const { key } = btn.dataset;
    const input = btn.parentElement.querySelector("input");
    if (!input) return;
    const newQty = Number(input.value) - 1;
    await l("/cart/change.js", { quantity: newQty < 0 ? 0 : newQty, id: key });
    this.build();
  }

  async increaseQty(evt) {
    const btn = evt.currentTarget;
    const { key } = btn.dataset;
    const input = btn.parentElement.querySelector("input");
    if (!input) return;
    const newQty = Number(input.value) + 1;
    const res = await l("/cart/change.js", { quantity: newQty, id: key, sections: this.sectionId ? this.sectionId : "" }).then((r) => r.json());
    if (res.status === 422 && res.message) {
      this.displayQtyError(btn.closest("[data-item]"), res.message);
      return;
    }
    this.build();
  }

  displayQtyError(t, e) {
    const a = t.querySelector("[data-error-msg]");
    if (a) {
      a.textContent = e;
      setTimeout(() => {
        a.textContent = "";
      }, 3000);
    }
  }

  async handleQtyChange(evt) {
    const el = evt.currentTarget;
    const { key } = el.dataset;
    await l("/cart/change.js", { quantity: evt.target.value, id: key });
    let s = await this.getCartPromise();
    window.JM.MiniCart.populateContainer(s);
  }

  async handleRemove(evt) {
    evt.preventDefault();
    const el = evt.currentTarget;
    const { key } = el.dataset;
    await l("/cart/change.js", { quantity: 0, id: key });
    this.build();
  }

  get itemsTemplateHtml() {
    return this.itemsTemplateTarget.innerHTML;
  }

  get sectionId() {
    var e;
    const t = this.element.querySelector("[data-section-id]") || this.element.closest(".shopify-section");
    return ((e = t == null ? void 0 : t.dataset) == null ? void 0 : e.sectionId) || null;
  }

  get itemsTemplate() {
    return window.Handlebars.compile(this.itemsTemplateHtml);
  }

  resetSlider() {
    window.$(".product-slider").slick({
      dots: false,
      infinite: true,
      autoplay: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      nextArrow: '<span class="slide-arrow arrow-next"><i class="fa fa-angle-right"></i></span>',
      prevArrow: '<span class="slide-arrow arrow-prev"><i class="fa fa-angle-left"></i></span>',
    });
    if (window.$(".product-slider").slick("getSlick").slideCount > 0) {
      window.$(".cart-upsell").removeClass("hide");
    }
    window.$("#nosto_cartdrawer .nosto-list").slick({ slidesToShow: 2 });
    setTimeout(() => {
      window.$("#nosto_cartdrawer .nosto-list").slick("setPosition");
    }, 150);
  }
}

u.values = {};
u.targets = ["cartBody", "savedCartBody", "removeItem", "cartCount", "itemsTemplate", "cartNote", "cartNoteContainer"];
u.debounces = ["handleNoteUpdate", "handleIsOpening", "loadNosto"];

const l = (h, t) =>
  fetch(h, {
    credentials: "same-origin",
    headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" },
    method: "POST",
    body: JSON.stringify(t),
  });

export { u as C };
